import { Navigate, useLocation } from 'react-router-dom'

/**
 * Component that redirects legacy URLs without /upt prefix to /upt/*
 * This handles email tracking links and other legacy routes that redirect without the /upt prefix.
 * Preserves all path segments, query parameters, and hash.
 */
export function LegacyUptRedirect() {
  const location = useLocation()

  // Build the new URL with /upt prefix, preserving query params and hash
  const newPath = `/upt${location.pathname}${location.search}${location.hash}`

  return <Navigate to={newPath} replace />
}
